import { get, put } from "./db.js";
import { appScopedKey } from "./namespace.js";
const MODEL_KEY = "classifier";
const TRAIN_KEY = "training-set";
const WORD_MODEL_KEY = "activation-word-model";
const WORD_CORPUS_KEY = "activation-word-corpus";
export async function saveModel(s) {
    console.info(`[model] saving classifier labels=${s.labels.join(",")}`);
    await put("baseline", appScopedKey(MODEL_KEY), s);
}
export async function loadModel() {
    const s = (await get("baseline", appScopedKey(MODEL_KEY))) ??
        null;
    if (s) {
        console.info(`[model] loaded classifier labels=${s.labels.join(",")}`);
    }
    else {
        console.info("[model] no saved classifier found");
    }
    return s;
}
export async function saveTrainingSet(data, dspFingerprint) {
    await put("baseline", appScopedKey(TRAIN_KEY), {
        __dspFingerprint: dspFingerprint ?? null,
        data,
    });
    console.debug("[model] training set persisted");
}
export async function loadTrainingSet() {
    const raw = await get("baseline", appScopedKey(TRAIN_KEY));
    if (!raw)
        return null;
    if (typeof raw === "object" &&
        raw !== null &&
        "data" in raw) {
        const wrapped = raw;
        return {
            data: wrapped.data ?? {},
            dspFingerprint: wrapped.__dspFingerprint ?? null,
        };
    }
    return {
        data: raw,
        dspFingerprint: null,
    };
}
function labelKey(qualifiedLabel) {
    return appScopedKey(`${TRAIN_KEY}:${qualifiedLabel}`);
}
export async function saveLabelCorpus(qualifiedLabel, rows, dspFingerprint) {
    const rec = {
        __dspFingerprint: dspFingerprint ?? null,
        rows: rows.map((r) => [...r]),
    };
    await put("baseline", labelKey(qualifiedLabel), rec);
    console.debug(`[model] label corpus persisted '${qualifiedLabel}' ` +
        `rows=${rows.length}`);
}
export async function loadLabelCorpus(qualifiedLabel) {
    const raw = await get("baseline", labelKey(qualifiedLabel));
    if (!raw)
        return null;
    return {
        rows: raw.rows ?? [],
        dspFingerprint: raw.__dspFingerprint ?? null,
    };
}
export async function clearLabelCorpus(qualifiedLabel) {
    await put("baseline", labelKey(qualifiedLabel), {
        __dspFingerprint: null,
        rows: [],
    });
    console.info(`[model] cleared label corpus '${qualifiedLabel}'`);
}
export async function saveActivationWordModel(s) {
    console.info(`[model] saving activation-word model labels=${s.labels.join(",")}`);
    await put("baseline", appScopedKey(WORD_MODEL_KEY), s);
}
export async function loadActivationWordModel() {
    const s = (await get("baseline", appScopedKey(WORD_MODEL_KEY))) ?? null;
    if (s) {
        console.info(`[model] loaded activation-word model labels=${s.labels.join(",")}`);
    }
    else {
        console.info("[model] no saved activation-word model found");
    }
    return s;
}
export async function saveActivationWordCorpus(data, dspFingerprint) {
    await put("baseline", appScopedKey(WORD_CORPUS_KEY), {
        __dspFingerprint: dspFingerprint ?? null,
        data,
    });
    console.debug("[model] activation-word corpus persisted");
}
export async function loadActivationWordCorpus() {
    const raw = await get("baseline", appScopedKey(WORD_CORPUS_KEY));
    if (!raw)
        return null;
    return {
        data: raw.data ?? {},
        dspFingerprint: raw.__dspFingerprint ?? null,
    };
}
